import { useQuery } from "@tanstack/react-query"
import { creditTransactionsQuery } from "../lib/creditTransactionsQuery"

export function useGetCreditTransactions(...args: Parameters<typeof creditTransactionsQuery>) {
  return useQuery(creditTransactionsQuery(...args))
}
